import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BackBtn from "../../common/backBTN";

function Promotion({ promotions }) {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState("All");

  // ✅ Unique promotion types
  const uniqueTypes = [...new Set(promotions.map(p => p.promotion_type))];

  // ✅ Filter Logic
  const filteredPromotions =
    selectedType === "All"
      ? promotions
      : promotions.filter(p => p.promotion_type === selectedType);

  const handleShowDetails = (promotionId) => {
    navigate(`/activityDetail?id=${promotionId}`);
  };
  

  return (
    <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
      <div className="_container_box">
        <div className="activity_container">
          <div className="shell-header">
            <div className="mc-navbar-blue this-mc-header am-navbar am-navbar-light">
              <BackBtn />
              <div className="am-navbar-title">Promotion</div>
              <div className="am-navbar-right" />
            </div>
          </div>

          <div className="activity-preview">
            <div className="activity_title">
              <div className="promo_menu hide-scrollbar">
                <div className="promo_menu_list">

                  
                  {uniqueTypes.map((type, index) => (
                    <div
                      className={`promo_menu_item ${selectedType === type ? "on" : ""}`}
                      key={index}
                      onClick={() => setSelectedType(type)}
                    >
                      <span>{type}</span>
                    </div>
                  ))}

                </div>
              </div>
            </div>

            <div className="activity_content">
              {filteredPromotions.length > 0 ? (
                filteredPromotions.map((promotion) => (
                  <div className="promo_item" key={promotion.id}>
                    <div className="activity">
                      <div className="activity_img">
                        <img
                          src={`${process.env.REACT_APP_API_URL}/storage/${promotion.thumbnail}`}
                          alt={promotion.name}
                        />
                      </div>
                      <div className="activity_info">
                        <div className="item-title">{promotion.name}</div>
                        <div
                          className="item-more"
                          onClick={() => handleShowDetails(promotion.id)}
                        >
                          More
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No data</p>
              )}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Promotion;
